import React, { useState } from "react";
import logo from "../../assets/images/logo.png";
import smLogo from "../../assets/ECO..svg";
import { HiOutlineMenuAlt1 } from "react-icons/hi";
import Wrapper from "../../helpers/Wrapper";
import { Link } from "react-router-dom";
import { AiOutlineUser } from "react-icons/ai";
import { BsCart } from "react-icons/bs";
import { TbHeart } from "react-icons/tb";
import { RiSearchLine } from "react-icons/ri";
import DotAlert from "../DotAlert";
import SearchPlace from "./SearchPlace";
import MobileNav from "./MobileNav";
import MiniCart from "./MiniCart";
import { useWishlists } from "../../hooks/useWishlists";
import { useCart } from "../../hooks/useCart";
import { motion } from 'framer-motion';
import { useConfig } from "../../context/ConfigContext";
import { navLinks } from "../../helpers/config";

function Header() {

  const [isOpen, setisOpen] = useState(false)
  const [isNavOpen, setIsNavOpen] = useState(false)

  const { data } = useCart();


  const handleNavOpen = () => {
    setIsNavOpen(!isNavOpen)
  }

  const handleOpen = () => {
    setisOpen(!isOpen)
  }

  const { data: wishlists } = useWishlists()
  const { setIsMiniCartOpen, isMiniCartOpen } = useConfig()

  return (
    <motion.header
      style={{
        position: 'sticky',
        top: '-1px',
        zIndex: 999999,
        background: 'white',
      }}
      className="w-full py-5  border-b">

      {/* Mobile Navigation */}
      <MobileNav isNavOpen={isNavOpen} callback={handleNavOpen} />

      {/* Search Place */}
      <SearchPlace isOpen={isOpen} callback={handleOpen} />

      {/* MiniCart Place  */}
      <MiniCart isOpen={isMiniCartOpen} callback={() => { setIsMiniCartOpen(!isMiniCartOpen) }} />

      <Wrapper>
        <div className="w-full flex justify-between items-center">
          {/* humbuger */}
          <div className="mr-5 lg:hidden">
            <button onClick={handleNavOpen}>
              <HiOutlineMenuAlt1 size={30} />
            </button>
          </div>
          {/* logo */}
          <div className="">
            <Link to="/">
              <img src={smLogo} alt="" className="w-20 lg:hidden" />
              <img src={logo} alt="" className="w-32 lg:w-36 hidden lg:block" />
            </Link>
          </div>

          {/* Nav Menu */}
          <div className="hidden lg:block">
            <nav className="">
              <ul className="flex items-center gap-10 font-[450]">
                {navLinks.map((link, i) => (
                  <li key={i}>
                    <Link to={link?.path}>{link?.title}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Icons and links */}
          <div className="flex gap-4 items-center md:gap-5">
            <button onClick={handleOpen} className="relative">
              <RiSearchLine size={25} />
            </button>
            <div className="hidden md:block relative">
              <DotAlert number={wishlists?.length || 0} />
              <div>
                <Link to="/wishlist"><TbHeart size={25} /></Link>
              </div>
            </div>
            <Link to='/account' className="relative hidden md:block">
              <AiOutlineUser size={25} />
            </Link>
            <button className="relative" onClick={() => { setIsMiniCartOpen(true) }}>
              <DotAlert number={data?.total_quantities || 0} />
              <BsCart size={25} />
            </button>
          </div>
        </div>
      </Wrapper>
    </motion.header>
  );
}

export default Header;
